<template>
  <b-form-group
    v-if="options && value !== undefined"
    class="custom-radio-input-gj"
  >
    <template v-slot:default="ariaDescribedby">
      <b-form-checkbox-group
        :aria-describedby="ariaDescribedby"
        name="datacenters"
      >
        <b-row class="w-full">
          <b-col
            v-for="option in groupOptionsByGeo"
            :key="`${option.name}${option.key}`"
            :cols="12"
            sm="6"
            :md="3"
            :class="{ 'order-2': option.disabled }"
          >
            <div
              class="d-flex flex-column custom-radio-input-option-gj mb-1 rounded datacenter-radio"
              style="cursor:default !important;"
              :class="
                `${isActive(option.ids) ? 'active' : ''} ${
                  option.disabled ? 'disabled opacity-7' : ''
                } `
              "
            >
              <div
                class="px-2 mt-1 flex-fill text-center"
                @click="selectDatacenter(option)"
              >
                <img
                  v-if="option.image"
                  :class="`mb-1 radio-img-shadow`"
                  :src="option.image"
                  style="width:65px;"
                  :alt="`${option.name} flag`"
                >
                <div
                  class="option-title text-thicker ml-0"
                  style="cursor:default !important;"
                >
                  {{ option.name }}
                </div>
              </div>
              <b-form-checkbox-group
                id="checkbox-group-2"
                v-model="selected"
                class="d-flex border-t mt-1 datacenter-options"
                :class="
                  isActive(option.ids)
                    ? 'border-primary-custom'
                    : 'border-default'
                "
              >
                <b-form-checkbox
                  v-for="(opt, index) in option.options"
                  :key="opt.slug"
                  :value="opt.id"
                  class="flex-fill"
                >
                  {{ index + 1 }}
                </b-form-checkbox>
              </b-form-checkbox-group>
            </div>
          </b-col>
        </b-row>
      </b-form-checkbox-group>
      <custom-alert
        class="info-alert mr-35 mb-0"
        variant="light"
        items-center
        icon-name="InfoAlt"
      >
        {{ options.length > 0 ? 'Choose at least one datacenter for your healthcheck.' : 'There are no datacenters available at the moment.' }}
      </custom-alert>
    </template>
  </b-form-group>
</template>
<script>
export default {
  name: 'DatacenterCheckbox',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    value: [String, Number, Boolean, Object, Array],
  },
  data() {
    return {
      selected: [],
    }
  },
  computed: {
    groupOptionsByGeo() {
      if (!this.options) return []

      const geos = [...new Set(this.options.map(el => el.name))]
      const geoArr = []
      geos.forEach(name => {
        const options = this.options.filter(el => el.name === name)
        const ids = options.map(({ id }) => id)
        let attrs = {}
        if (options[0]) {
          const tempNameArr = options[0].name.split(' ')
          const tempName = tempNameArr.length > 1
            ? tempNameArr.slice(0, -1).join(' ')
            : tempNameArr[0]
          attrs = {
            image: options[0].imageUrl,
            tempName,
            disabled: !this.checkChildren(options),
            ids,
          }
        }
        geoArr.push({ name, options, ...attrs })
      })
      return geoArr
    },
    options() {
      return this.$store.state.healthchecks.datacenters
    },
  },
  watch: {
    selected(val) {
      this.$emit('input', val)
    },
  },
  mounted() {
    this.selected = this.value
    if (this.selected.length === 0 && this.options.length > 0) {
      this.selected.push(this.options[0].id)
    }
  },
  methods: {
    checkChildren(options) {
      return options.some(op => op.isAvailable)
    },
    selectDatacenter(option) {
      if (this.isActive(option.ids)) {
        this.selected = this.selected.filter(id => !option.ids.includes(id))
        return
      }
      this.selected.push(option.ids[0])
    },
    isActive(ids) {
      return this.selected.some(r => ids.indexOf(r) >= 0)
    },
  },
}
</script>
<style lang="scss" scoped>
.datacenter-options::v-deep {
  .custom-control {
    padding: 0;
    margin: 0;
    .custom-control-label {
      width: 100%;
      height: 100%;
      border: 1px solid #e0e5eb;
      border-top-color: rgba(0, 0, 0, 0);
      border-bottom: none !important;

      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;

      &::after, &::before {
        content: none;
      }
    }
    .custom-control-input:checked ~ .custom-control-label {
      background-color: rgba(29, 121, 242, 0.1);
      border: 1px solid var(--primary);
      border-top: none !important;
      border-bottom: none !important;
      color: var(--primary);
      font-weight: 700;
    }
    &:first-child .custom-control-input:checked ~ .custom-control-label {
      border-left: none;
    }
    &:last-child .custom-control-input:checked ~ .custom-control-label {
      border-right: none;
    }
  }
}
</style>
